import cx from 'classnames';
import { TextBlockView } from '@plone/volto-slate/blocks/Text';
import type { BlockViewProps } from '@plone/types';
import { defineMessages, useIntl } from 'react-intl';

import styles from '@redturtle/qubicaamf-theme/components/Blocks/Testimonials/styles.module.css';
import './testimonials.scss';
import type { TestimonialsData } from '@redturtle/qubicaamf-theme/components/Blocks/Testimonials/schema';

import config from '@plone/registry';
import CTA from '@redturtle/qubicaamf-theme/components/Blocks/commons/CTA';
import TestimonialSwiper from './Components/TestimonialSwiper';

type Props = BlockViewProps & {
  data: TestimonialsData;
};

export default function View({ data, className, style }: Props) {
  const intl = useIntl();
  const Container = config.getComponent('Container').component || 'div';

  return (
    <section
      className={cx('block-testimonials', styles.block, className)}
      style={style}
      aria-label={data.title}
    >
      <Container
        className={cx('block-testimonials-container', styles.container)}
      >
        <div
          className={cx(
            'block-testimonials-testimonials-wrapper',
            styles['testimonials-wrapper'],
          )}
        >
          {data.testimonials?.length > 0 ? (
            <TestimonialSwiper data={data.testimonials} />
          ) : (
            <div className="image-add">
              {intl.formatMessage(
                messages.add_testimonials_from_edit_mode_label,
              )}
            </div>
          )}
        </div>
        <div className={cx('block-testimonials-body', styles.body)}>
          {data.title && (
            <h2 className={cx('block-testimonials-title', styles.title)}>
              {data.title}
            </h2>
          )}
          {data.text && (
            <div className={cx('block-testimonials-text', styles.text)}>
              <TextBlockView data={{ value: data.text ?? {} }} />
            </div>
          )}
          {data.linkHref?.[0] && (
            <CTA
              href={data.linkHref[0]['@id']}
              openLinkInNewTab={false}
              ctaButtonStyle={data.ctaButtonStyle}
              linkIcon={data.linkIcon}
              cta_color={data.cta_color}
            >
              {data.linkTitle}
            </CTA>
          )}
        </div>
      </Container>
    </section>
  );
}

const messages = defineMessages({
  add_testimonials_from_edit_mode_label: {
    id: 'add_testimonials_from_edit_mode_label',
    defaultMessage: 'Add Testimonials from edit mode',
  },
});
